<template>
  <div class="dash-root">
    <vue-element-loading :active="appLoading" spinner="bar-fade-scale" color="#3ea56e" size="128" is-full-screen />
    <v-snackbar v-model="showsnackbar" color="#333333" right :timeout="5000">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    
    <ServerError v-if="ServerError" />

    <div v-if="product && product._id">
      <div class="dash-page-header">
        <div>
          <p class="dash-page-header__eyebrow">Product Management</p>
          <h1 class="dash-page-header__title">Product Details</h1>
        </div>
        <div class="dash-page-header__actions">
          <v-btn
            v-if="product.status == 'Pending' || product.status =='Updated' || product.status =='Rejected'"
            class="btn-submit"
            style="background: #10b981 !important; color: white !important;"
            @click="dialogapprove = true"
            depressed
          >
            <v-icon left size="20">mdi-check-circle-outline</v-icon> Approve
          </v-btn>
          
          <v-btn
            v-if="product.status == 'Pending' || product.status =='Rejected'"
            class="btn-submit"
            style="background: #f59e0b !important; color: white !important;"
            @click="dialogReject = true"
            depressed
          >
            <v-icon left size="20">mdi-close-circle-outline</v-icon> Reject
          </v-btn>

          <v-btn
            class="btn-submit"
            style="background: #ef4444 !important; color: white !important;"
            @click="dialog = true"
            depressed
          >
            <v-icon left size="20">mdi-delete-outline</v-icon> Delete
          </v-btn>

          <v-btn
            class="btn-submit"
            style="background: #0ea5e9 !important; color: white !important;"
            @click="edit(product._id)"
            depressed
          >
            <v-icon left size="20">mdi-pencil-outline</v-icon> Edit
          </v-btn>
        </div>
      </div>

      <div class="product-layout mt-6">
        <!-- Left Column: Gallery -->
        <div class="product-gallery-section">
          <v-card class="modern-card pa-4" elevation="0">
            <div class="main-image-wrapper">
              <template v-if="photos && photos.length > 0">
                <span class="hidden-md-and-up">
                  <v-img v-if="!curImage" :src="mediaUURL + photos[0]" max-height="400" contain></v-img>
                  <v-img v-if="curImage" :src="mediaUURL + curImage" max-height="400" contain></v-img>
                </span>
                <span class="hidden-sm-and-down">
                  <inner-image-zoom
                    v-if="!curImage"
                    :src="mediaUURL + photos[0]"
                    :zoom-src="mediaUURL + photos[0]"
                    zoomType="hover"
                    :hideHint="true"
                    :zoomPreload="true"
                  ></inner-image-zoom>
                  <inner-image-zoom
                    v-if="curImage"
                    :src="mediaUURL + curImage"
                    :zoom-src="mediaUURL + curImage"
                    zoomType="hover"
                    :hideHint="true"
                    :zoomPreload="true"
                  ></inner-image-zoom>
                </span>
              </template>
              <template v-else>
                <v-img :src="require('../../assets/noimg.png')" max-height="400" contain></v-img>
              </template>
            </div>

            <div class="thumbnail-row mt-4" v-if="photos && photos.length > 0">
              <div
                v-for="(item, i) in photos"
                :key="i"
                class="thumbnail-wrapper"
                :class="{'active-thumb': (curImage ? curImage === item : i === 0)}"
                @click="showImage(item); imageUrl = item"
              >
                <v-img :src="mediaUURL + item" height="80" contain></v-img>
              </div>
            </div>
          </v-card>
          
          <v-card class="modern-card pa-6 mt-6" elevation="0">
             <h3 class="section-title mb-4">Pricing & Inventory</h3>
             <div class="info-list">
                <div class="info-list-row">
                  <span class="info-label">Stock Quantity</span>
                  <span class="info-value" style="color: #10b981;">{{ product.quantity }}</span>
                </div>
                <div class="info-list-row">
                  <span class="info-label">Min Order Qty</span>
                  <span class="info-value">{{ product.minimumOrderQuantity || '1' }}</span>
                </div>
                <div class="info-list-row">
                  <span class="info-label">Max Order Qty</span>
                  <span class="info-value">{{ product.maxOrderQuantity || 'N/A' }}</span>
                </div>
                <div class="info-list-row">
                  <span class="info-label">Packing Charge</span>
                  <span class="info-value">Rs. {{ product.packingCharge || '0' }}</span>
                </div>
                <div class="info-list-row">
                  <span class="info-label">Delivery (Inside Kerala)</span>
                  <span class="info-value">Rs. {{ product.deliveryChargeInsideKerala || '0' }}</span>
                </div>
                <div class="info-list-row">
                  <span class="info-label">Delivery (Outside Kerala)</span>
                  <span class="info-value">Rs. {{ product.deliveryChargeOutsideKerala || '0' }}</span>
                </div>
                <div class="info-list-row">
                  <span class="info-label">Tax</span>
                  <span class="info-value">{{ product.tax || '0' }}%</span>
                </div>
             </div>
          </v-card>
        </div>

        <!-- Right Column: Details -->
        <div class="product-details-section">
          <v-card class="modern-card pa-6" elevation="0" style="height: 100%;">
            <div class="product-header-block mb-6">
              <h1 class="product-title">{{ product.productname }}</h1>
              
              <div class="product-meta mt-2">
                <div class="rating-block">
                  <v-rating
                    :value="parseFloat(product.rating)"
                    color="#f59e0b"
                    background-color="#e2e8f0"
                    empty-icon="mdi-star-outline"
                    half-increments
                    readonly
                    small
                    dense
                  ></v-rating>
                  <!-- <span class="rating-count">({{ product.ratingcount }} reviews)</span> -->
                </div>
                <v-chip v-if="product.offer" class="offer-chip ml-4" small color="#ecfdf5" text-color="#10b981">
                  {{ product.offer }}% OFF
                </v-chip>
              </div>
              
              <div class="price-block mt-4">
                <span class="current-price">
                  Rs. {{ product.offerPrice ? product.offerPrice : product.price }}
                </span>
                <span class="original-price ml-2" v-if="product.offerPrice && product.offerPrice != product.price">
                  Rs. {{ product.price }}
                </span>
                <v-chip class="stock-chip ml-4" small :color="product.quantity ? '#ecfdf5' : '#fef2f2'" :text-color="product.quantity ? '#10b981' : '#ef4444'">
                  {{ product.quantity ? 'In Stock' : 'Out of Stock' }}
                </v-chip>
              </div>
            </div>

            <v-divider class="mb-6"></v-divider>

            <h3 class="section-title mb-4">Categorization</h3>
            <div class="categories-block mb-6">
              <div class="category-row mb-2" v-if="product.mainCategory">
                <span class="category-label">Main Category:</span>
                <v-chip class="modern-chip ml-2" small>{{ product.mainCategory.name }}</v-chip>
              </div>
              <div class="category-row mb-2" v-if="categoryArray && categoryArray.length > 0">
                <span class="category-label">Category:</span>
                <v-chip v-for="(item, i) in categoryArray" :key="i" class="modern-chip ml-2" small>{{ item.name }}</v-chip>
              </div>
              <div class="category-row" v-if="subcat && subcat.length > 0">
                <span class="category-label">Sub-Category:</span>
                <v-chip v-for="(list, j) in subcat" :key="j" class="modern-chip ml-2" small>{{ list.name }}</v-chip>
              </div>
            </div>

            <v-divider class="mb-6"></v-divider>

            <h3 class="section-title mb-4" v-if="product.description">Description</h3>
            <div class="product-description mb-6" v-if="product.description">
              {{ product.description }}
            </div>

            <v-divider class="mb-6" v-if="product.specifications"></v-divider>

            <h3 class="section-title mb-4" v-if="product.specifications">Specifications</h3>
            <div class="product-specifications" v-if="product.specifications" v-html="product.specifications">
            </div>
            
          </v-card>
        </div>
      </div>

      <!-- Modals -->
      <v-dialog v-model="dialogapprove" max-width="500px" content-class="modern-dialog">
        <v-card class="modern-dialog-card">
          <v-card-title class="modern-dialog-header">
            Approve Product
          </v-card-title>
          <v-card-text class="modern-dialog-body pt-6">
            <p style="font-family: poppinsmedium, sans-serif; font-size: 15px; color: #334155;">
              Are you sure you want to approve this product? It will become visible on the platform.
            </p>
          </v-card-text>
          <v-card-actions class="modern-dialog-actions">
            <v-spacer></v-spacer>
            <v-btn text class="btn-cancel" @click="dialogapprove = false">Cancel</v-btn>
            <v-btn class="btn-submit" style="background: #10b981 !important; box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2) !important;" @click="approveProduct()">Approve</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogReject" max-width="500px" content-class="modern-dialog">
        <v-card class="modern-dialog-card">
          <v-card-title class="modern-dialog-header">
            Reject Product
          </v-card-title>
          <v-card-text class="modern-dialog-body pt-6">
            <p style="font-family: poppinsmedium, sans-serif; font-size: 15px; color: #334155;">
              Are you sure you want to reject this product?
            </p>
            <v-text-field
              v-model="reason"
              label="Reason for rejection"
              outlined
              dense
              class="modern-input mt-4"
            ></v-text-field>
          </v-card-text>
          <v-card-actions class="modern-dialog-actions">
            <v-spacer></v-spacer>
            <v-btn text class="btn-cancel" @click="dialogReject = false">Cancel</v-btn>
            <v-btn class="btn-submit" style="background: #f59e0b !important; box-shadow: 0 4px 12px rgba(245, 158, 11, 0.2) !important;" @click="rejectProduct()">Reject</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog" max-width="500px" content-class="modern-dialog">
        <v-card class="modern-dialog-card">
          <v-card-title class="modern-dialog-header">
            Delete Product
          </v-card-title>
          <v-card-text class="modern-dialog-body pt-6">
            <p style="font-family: poppinsmedium, sans-serif; font-size: 15px; color: #334155;">
              Are you sure you want to delete this product? This action cannot be undone.
            </p>
          </v-card-text>
          <v-card-actions class="modern-dialog-actions">
            <v-spacer></v-spacer>
            <v-btn text class="btn-cancel" @click="dialog = false">Cancel</v-btn>
            <v-btn class="btn-submit" style="background: #ef4444 !important; box-shadow: 0 4px 12px rgba(239, 68, 68, 0.2) !important;" @click="removeProduct()">Delete</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </div>
  </div>
</template>
<script>
import axios from "axios";
import InnerImageZoom from "vue-inner-image-zoom";
import "vue-inner-image-zoom/lib/vue-inner-image-zoom.css";
// import ImageZoomer from "./imageZoomer";
export default {
  props: ["productid"],
  components: {
    // ImageZoomer,
    "inner-image-zoom": InnerImageZoom,
  },
  data() {
    return {
      checkbox: true,
      tagsArray: [],
      msg: "",
      collectionid: "",
      stylCategoryArray: [],
      subcategoryArray: [],
      dialogdelete: false,
      showsnackbar: false,
      dialogadd: false,
      dialogapprove: false,
      dialogReject: false,
      productRating: 4,
      dialog: false,
      curImage: null,
      product: [],
      subcat: [],
      show: false,
      sizes: [],
      size: [],
      styl: [],
      stylCategory: [],
      productname: "",
      categoryArray: [],
      appLoading: false,
      ServerError: false,
      photos: [],
      name: "",
      productSize: {},
      selectedProduct: {},
      sizeChartDialog: false,
      sizeChart: null,
      commissionPercentage: null,
      deliveryCharge: null,
      imageUrl: null,
      reason: "",
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    showImage(item) {
      this.curImage = item;
    },
    getData() {
      this.appLoading = true;
      var data = {};
      data["id"] = this.$route.params.id;
      axios({
        method: "POST",
        url: "/product/view",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.product = response.data.data;
            if (this.product.status === 'Updated' && this.product.updatedProducts) {
              const updates = this.product.updatedProducts;
              for (const key in updates) {
                if (updates[key] !== undefined && updates[key] !== null && key !== 'category' && key !== 'subcategory' && key !== 'mainCategory') {
                  this.product[key] = updates[key];
                }
              }
            }
            if (this.product.photos) this.photos = this.product.photos;
            this.categoryArray = this.product.category;
            this.subcat = response.data.data.subcategory;
            if (this.product.photos && this.product.photos.length > 0) {
              this.imageUrl = this.product.photos[0];
            }
            this.appLoading = false;
          } else {
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((e) => {
          //   this.ServerError = true;
          console.log(e);
        });
    },
    rejectProduct() {
      axios({
        method: "POST",
        url: "/product/approve",
        data: {
          id: this.$route.params.id,
          approve: false,
          reason: this.reason,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.dialog = false;
            this.appLoading = false;
            this.getData();
            this.$router.go(-1);
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.appLoading = false;
          }
        })
        .catch((e) => {
          this.ServerError = true;
          console.log(e);
        });
    },
    approveProduct() {
      axios({
        method: "POST",
        url: "/product/approve",
        data: {
          id: this.$route.params.id,
          approve: true,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.dialog = false;
            this.appLoading = false;
            this.getData();
            this.$router.go(-1);
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.appLoading = false;
          }
        })
        .catch((e) => {
          this.ServerError = true;
          console.log(e);
        });
    },
    removeProduct() {
      var data = {};
      data["id"] = this.$route.params.id;
      axios({
        method: "POST",
        url: "/product/delete",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.dialog = false;
            this.appLoading = false;
            this.$router.go(-1);
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.appLoading = false;
          }
        })
        .catch((e) => {
          this.ServerError = true;
          console.log(e);
        });
    },
    edit(pid) {
      this.$router.push("/productEdit?product=" + pid);
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
  },
};
</script>
<style scoped>
.dash-root { font-family: poppinsmedium, Roboto, sans-serif; padding: 12px 12px; }
.dash-page-header { display: flex; align-items: flex-end; justify-content: space-between; margin-bottom: 24px; flex-wrap: wrap; gap: 16px; }
.dash-page-header__eyebrow { font-size: 13px; color: #8a93a4; margin: 0 0 4px; font-family: poppinsmedium, sans-serif; text-transform: uppercase; letter-spacing: 0.5px; }
.dash-page-header__title { font-size: 22px; font-weight: 700; color: #1a202c; margin: 0; font-family: poppinsbold, sans-serif; line-height: 1.2; }
.dash-page-header__actions { display: flex; gap: 12px; }

.btn-submit { background: #3ea56e !important; color: #ffffff !important; font-family: poppinsmedium, sans-serif; text-transform: none; font-size: 14px; letter-spacing: 0; border-radius: 8px; padding: 0 16px !important; box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05) !important; }

.modern-card { background: #ffffff; border: 1px solid #eaedf0; border-radius: 12px; overflow: hidden; box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02) !important; }

.product-layout { display: grid; grid-template-columns: 1fr 2fr; gap: 24px; }
@media (max-width: 960px) {
  .product-layout { grid-template-columns: 1fr; }
}

.main-image-wrapper { background: #f8fafc; border-radius: 8px; padding: 16px; border: 1px solid #f1f5f9; display: flex; justify-content: center; align-items: center; min-height: 400px; }
.thumbnail-row { display: flex; gap: 12px; flex-wrap: wrap; justify-content: center; }
.thumbnail-wrapper { width: 80px; height: 80px; border-radius: 8px; border: 2px solid transparent; cursor: pointer; overflow: hidden; background: #f8fafc; transition: all 0.2s ease; }
.thumbnail-wrapper:hover { border-color: #cbd5e1; }
.thumbnail-wrapper.active-thumb { border-color: #3ea56e; }

.section-title { font-size: 18px; font-weight: 600; color: #1e293b; font-family: poppinssemibold, sans-serif; margin: 0; }

.info-list { display: flex; flex-direction: column; gap: 12px; }
.info-list-row { display: flex; justify-content: space-between; align-items: center; padding-bottom: 12px; border-bottom: 1px solid #eaedf0; }
.info-list-row:last-child { padding-bottom: 0; border-bottom: none; }
.info-label { font-size: 13px; color: #64748b; text-transform: uppercase; letter-spacing: 0.5px; font-family: poppinsmedium, sans-serif; }
.info-value { font-size: 15px; color: #1e293b; font-weight: 600; font-family: poppinssemibold, sans-serif; }

.product-title { font-size: 28px; font-weight: 700; color: #0f172a; margin: 0; font-family: poppinsbold, sans-serif; line-height: 1.3; }
.product-meta { display: flex; align-items: center; }
.rating-block { display: flex; align-items: center; gap: 8px; }
.rating-count { font-size: 14px; color: #64748b; }
.offer-chip { font-weight: 600; font-family: poppinssemibold, sans-serif; }

.price-block { display: flex; align-items: center; }
.current-price { font-size: 28px; font-weight: 700; color: #0f172a; font-family: poppinsbold, sans-serif; }
.original-price { font-size: 16px; color: #94a3b8; text-decoration: line-through; }
.stock-chip { font-weight: 600; font-family: poppinssemibold, sans-serif; }

.category-row { display: flex; align-items: flex-start; }
.category-label { font-size: 14px; color: #64748b; font-weight: 500; width: 140px; flex-shrink: 0; text-align: left; padding-top: 2px; }
.modern-chip { background: #f1f5f9 !important; color: #334155 !important; font-family: poppinsmedium, sans-serif; font-size: 13px !important; border-radius: 6px; }

.product-description { font-size: 15px; color: #475569; line-height: 1.6; font-family: Roboto, sans-serif; white-space: pre-wrap; }
.product-specifications { font-size: 15px; color: #475569; line-height: 1.6; font-family: Roboto, sans-serif; }
::v-deep .product-specifications ul { padding-left: 20px; margin-bottom: 16px; }
::v-deep .product-specifications li { margin-bottom: 8px; }

/* Dialog Styles */
::v-deep .modern-dialog { border-radius: 16px !important; overflow: hidden; }
.modern-dialog-card { border-radius: 16px !important; }
.modern-dialog-header { background: #f8fafc; border-bottom: 1px solid #eaedf0; padding: 20px 24px !important; font-family: poppinssemibold, sans-serif; font-size: 18px; color: #1e293b; }
.modern-dialog-body { padding: 24px !important; background: #ffffff; }
.modern-dialog-actions { padding: 16px 24px !important; background: #f8fafc; border-top: 1px solid #eaedf0; }
.btn-cancel { color: #64748b !important; font-family: poppinsmedium, sans-serif; text-transform: none; font-size: 14px; letter-spacing: 0; border-radius: 8px; }
.modern-input ::v-deep .v-input__control .v-input__slot { border-radius: 8px; }
</style>
